import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { colors } from '@guryou/colors';
import { FlexRow, Spinner } from '@guryou/html-components';
import { completeCustomerInvitationFlow, getCustomerInvitationFlow, stateIsLoaded, stateIsLoading } from '@guryou/redux';

import FlowStepper from './FlowStepper';

const InviteFlow = ({ customerFlowId, email }) => {
  const dispatch = useDispatch();
  const hasCompletedRef = useRef(false);
  const history = useHistory();

  const flowSelector = useSelector(state => state.customersInvitationFlow.customerInvitationFlow);

  useEffect(() => {
    if (customerFlowId) {
      dispatch(getCustomerInvitationFlow(customerFlowId));
    }
  }, [dispatch, customerFlowId]);

  // marks flow as completed after setting up password, only for flow without steps
  // the one with steps is marked as completed after doing all the steps
  // navigate only after the complete API call finishes so tokens aren't cleared mid-request
  useEffect(() => {
    if (hasCompletedRef.current) return;
    if (!stateIsLoaded(flowSelector)) return;

    const flow = flowSelector?.data;
    const steps = flow?.steps;
    const hasNoSteps = !steps || steps.length === 0;

    if (hasNoSteps && customerFlowId) {
      hasCompletedRef.current = true;
      if (!flow?.completedAt) {
        dispatch(completeCustomerInvitationFlow(customerFlowId)).then(() => {
          history.replace('/successFlow', { appConfig: flow?.appConfig });
        });
      } else {
        history.replace('/successFlow', { appConfig: flow?.appConfig });
      }
    }
  }, [flowSelector, customerFlowId, dispatch, history]);

  const flow = flowSelector?.data;
  const hasNoSteps = !flow?.steps || flow.steps.length === 0;

  if (stateIsLoading(flowSelector) || (stateIsLoaded(flowSelector) && hasNoSteps)) {
    return (
      <div className="mx-auto w-full max-w-4xl bg-white rounded-lg shadow-md p-4 sm:p-8">
        <Spinner />
      </div>
    );
  }

  return (
    <FlexRow xs={12} alignItems="flex-start" minHeight="100%" paddingTop="4vh" paddingBottom="4vh" backgroundColor={colors.mineShaft} margin={0}>
      <FlowStepper flowData={flowSelector.data || []} email={email} />
    </FlexRow>
  );
};

export default withRouter(InviteFlow);